import { Axios } from 'utils'
import { AcceptTOURequest, TOUVersionResponse, TOUStatusResponse } from 'types'

export const touServices = () => {
  const getCurrentTOU = async (): Promise<TOUVersionResponse> => {
    try {
      const response = await Axios.get<{ result: TOUVersionResponse }>(
        `/tou/current`
      )
      return response.data.result
    } catch (error: unknown) {
      throw error
    }
  }

  const getTOUContent = async (versionId: number): Promise<string> => {
    const { data } = await Axios.get(`/tou/content/${versionId}`, {
      responseType: 'text',
    })
    return data
  }

  const acceptTOU = async (payload: AcceptTOURequest) => {
    try {
      const response = await Axios.post(`/tou/accept`, payload)
      return response.data
    } catch (error: unknown) {
      throw error
    }
  }

  return {
    getCurrentTOU,
    getTOUContent,
    acceptTOU,
  }
}
